import { useTranslate } from '@refinedev/core';
import { Card, Flex, Rate, Space, Statistic, theme } from 'antd';
import type { PublicationDetailOut } from '@/api/generated/schemas';
import { formatRating, formatThousands } from '@/utils/format';

interface PublicationReviewsTabProps {
  record: PublicationDetailOut;
}

export const PublicationReviewsTab = ({
  record,
}: PublicationReviewsTabProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  return (
    <Card>
      <Flex gap={token.marginXL + token.margin} wrap>
        <Statistic
          title={t('user_catalog.publications.show.reviews.total_rating')}
          valueRender={() => (
            <Space size={token.marginSM}>
              {record.total_rating != null
                ? formatRating(record.total_rating)
                : '—'}
              <Rate
                disabled
                allowHalf
                value={record.total_rating ?? 0}
                style={{ fontSize: token.fontSizeHeading4 }}
              />
            </Space>
          )}
        />
        <Statistic
          title={t('user_catalog.publications.fields.reviews_count')}
          value={formatThousands(record.reviews_count ?? 0) ?? '0'}
        />
      </Flex>
    </Card>
  );
};
